module.exports = __webpack_public_path__ + "img/xdl.9ad0d723.png";